import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DeliveryCompanyListItem } from "../../deliveryCompanies.types";
import { DELIVERY_COMPANIES_QUERY_KEY } from "../useGetDeliveryCompanies/useGetDeliveryCompanies";
import { requestGetDeliveryCompany } from "./getDeliveryCompany.request";

const useGetDeliveryCompany = (
  companyId: string | undefined,
  options?: QueryOptions<DeliveryCompanyListItem, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: [DELIVERY_COMPANIES_QUERY_KEY, "admin", "one", companyId],
    queryFn: async () => await requestGetDeliveryCompany(companyId as string),
    enabled: !!companyId,
    ...options
  });

  return { company: data, ...rest };
};

export default useGetDeliveryCompany;
